import { companyOpportunitiesRoutine, aggregatorOpportunityIdRoutine, aggregatorFormSubmittedRoutine, OPPORTUNITY_CLEANUP } from './routines'
import requestFlow from '@/utils/requestFlow'
import { getCompanyOpportunities } from '@product/api/aggregator'
import { logoutRoutine } from '@/store/modules/auth/routines'
import { state as initialState } from './index'

export default {
  ...requestFlow(companyOpportunitiesRoutine, getCompanyOpportunities).actions,

  [aggregatorOpportunityIdRoutine.TRIGGER](context, payload) {
    context.commit(aggregatorOpportunityIdRoutine.TRIGGER, payload)
  },

  [aggregatorFormSubmittedRoutine.TRIGGER](context, payload) {
    context.commit(aggregatorFormSubmittedRoutine.TRIGGER, payload)
    context.dispatch(aggregatorFormSubmittedRoutine.SUCCESS, payload)
  },

  [aggregatorFormSubmittedRoutine.SUCCESS](context, payload) {
    context.commit(aggregatorFormSubmittedRoutine.SUCCESS, payload)
  },

  [logoutRoutine.SUCCESS](context) {
    context.commit(OPPORTUNITY_CLEANUP, initialState)
  }
}
